import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';

// Barre latérale repliée par défaut. Backstage l'épingle (dépliée) par défaut
// et réécrit sidebarPinState à chaque chargement, donc tous les navigateurs
// ayant déjà visité le site ont la clé à true : on la force à false une seule
// fois (marqueur ci-dessous), puis on respecte le choix de l'utilisateur.
const SIDEBAR_DEFAULT_APPLIED_KEY = 'kaizen.sidebarCollapsedDefaultApplied';
try {
  if (window.localStorage.getItem(SIDEBAR_DEFAULT_APPLIED_KEY) === null) {
    window.localStorage.setItem('sidebarPinState', 'false');
    window.localStorage.setItem(SIDEBAR_DEFAULT_APPLIED_KEY, 'true');
  }
} catch {
  // localStorage indisponible : on garde le comportement par défaut.
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
